import * as React from 'react';

import MuiTextField, { TextFieldProps as MuiTextFieldProps } from '@material-ui/core/TextField';
import Skeleton from 'react-loading-skeleton';

export type TextFieldProps = MuiTextFieldProps & {
  fdKey: string;
  loading?: boolean;
};

const TextField = ({ fdKey, loading, ...rest }: TextFieldProps) =>
  loading ? (
    <Skeleton width="100%" height="32px" />
  ) : (
    <MuiTextField
      {...rest}
      inputProps={{
        ...rest.inputProps,
        'data-fd': fdKey,
      }}
    />
  );

export default TextField;
